export const PRICING_WIZARD = 'ab-pricing-wizard';

export const abExperimentData = {
  'ab-pricing-wizard': 'newPricingwizard'
};

export const getWinningVariant = (winningVariants = [], experimentName) => {
  const winnerVariant = winningVariants.find(e => e.experiment === experimentName);

  if (!winnerVariant) {
    return null;
  }

  return winnerVariant.name;
};

export default {
  getWinningVariant,
  abExperimentData
};



// WEBPACK FOOTER //
// ./src/pages/pricing/abUtils.js